import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import {
  faCheckSquare,
  faCoffee,
  faEllipsisV,
  faTable,
  faHouse,
  faStar,
  faSection,
  faUsers,
  faFileInvoice,
  faSpinner,
  faCalendar,
  faSignal,
  faGears,
  faServer,
  faList,
  faCopy,
  faEnvelope,
  faBan,
  faMessage,
  faHardDrive,
  faIdBadge,
  faPerson,
  faContactCard,
  faAddressCard,
  faIdCardClip,
  faBell,
  faUserTie,
  faUserShield,
  faCheck,
  faPenNib,
  faCalendarPlus,
  faUsersGear,
  faUsersLine,
  faCommentSms,
  faEnvelopeOpen,
  faCalendarDays,
  faCalendarCheck,
  faTruckFast,
  faChartLine,
  faICursor,
  faPersonWalking,
  faGear,
  faFolder,
  faGauge,
  faListOl,
  faReceipt,
  faBuilding,
  faScaleBalanced,
  faPercent,
  faWarehouse,
  faSitemap,
  faObjectGroup,
  faSquare,
  faClipboardList,
  faSliders,
  faLink,
  faBoxesPacking,
  faShop,
  faFileLines,
  faFileCircleCheck,
  faPrint,
  faBuildingColumns,
  faCircleCheck,
  faMoneyBill,
  faCreditCard,
  faNewspaper,
  faBagShopping,
  faPhoneVolume,
  faBookBookmark,
  faTruck,
  faCircleInfo,
  faStore,
  faDashboard,
  faUser,
  faUserPen,
  faPeopleGroup,
  faFilePen,
  faPeopleRoof,
  faUserTag,
  faCheckDouble,
  faLayerGroup,
  faNetworkWired,
  faUserCircle,
  faCircleExclamation,
  faFolderPlus,
  faPenFancy,
  faCrown,
  faScroll,
  faBullhorn,
  faClone,
  faCubes,
  faUpload,
  faSearch,	
  faIndustry,
  faRectangleAd,
  faSuitcase,
  faImage,
  faPhotoFilm,
  faWindowRestore,
  faPager,
  faRotateLeft,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";

export const fontAwesomeIcons = [
  faCheckSquare,
  faCoffee,
  faEllipsisV,
  faTable,
  faDashboard,
  faHouse,
  faStar,
  faSection,
  faUsers,
  faFileInvoice,
  faSpinner,
  faCalendar,
  faSignal,
  faGears,
  faServer,
  faList,
  faCopy,
  faEnvelope,
  faMessage,
  faBan,
  faHardDrive,
  faIdBadge,
  faPerson,
  faContactCard,
  faAddressCard,
  faIdCardClip,
  faBell,
  faUserShield,
  faCheck,
  faPenNib,
  faCalendarPlus,
  faUsersLine,
  faCommentSms,
  faEnvelopeOpen,
  faCalendarDays,
  faCalendarCheck,
  faTruckFast,
  faChartLine,
  faICursor,
  faPersonWalking,
  faGear,
  faFolder,
  faGauge,
  faListOl,
  faReceipt,
  faBuilding,
  faScaleBalanced,
  faPercent,
  faWarehouse,
  faSitemap,
  faObjectGroup,
  faHardDrive,
  faClipboardList,
  faSliders,
  faFileInvoice,
  faLink,
  faBoxesPacking,
  faShop,
  faFileLines,
  faFileCircleCheck,
  faPrint,
  faBuildingColumns,
  faCircleCheck,
  faMoneyBill,
  faCreditCard,
  faNewspaper,
  faBagShopping,
  faPhoneVolume,
  faBookBookmark,
  faTruck,
  faCircleInfo,
  faTruckFast,
  faStore,
  faMoneyBill,
  faUser,
  faUserPen,
  faPeopleGroup,
  faCalendarPlus,
  faFilePen,
  faUserShield,
  faPeopleRoof,
  faUserTag,
  faCheckDouble,
  faLayerGroup,
  faNetworkWired,
  faUserCircle,
  faCircleExclamation,
  faFolderPlus,
  faPenFancy,
  faStar,
  faCrown,
  faScroll,
  faBullhorn,
  faClone,
  faMoneyBill,
  faCubes,
  faUpload,
  faSearch,
  faIndustry,
  faRectangleAd,
  faSuitcase,
  faImage,
  faPhotoFilm,
  faWindowRestore,
  faPager,
  faRotateLeft,
  faFileContract,
];
